/* eslint-disable no-underscore-dangle */
// HubSpot Core Utilities
// Internal functions for HubSpot queue management and low-level operations

import logger from '@pray/shared/utils/logger';

import type { HubSpotCommand } from './types';

declare const window: {
  _hsq?: Array<unknown> | null;
} & Window;

/**
 * Initialize HubSpot tracking queue if not already present
 */
export function initializeHubSpotQueue(): void {
  if (typeof window !== 'undefined') {
    window._hsq = window._hsq || [];
  }
}

/**
 * Push a command to the HubSpot tracking queue
 * @param command - Array containing the command and its parameters
 */
export function pushToHubSpot(command: HubSpotCommand): void {
  if (typeof window !== 'undefined') {
    initializeHubSpotQueue();
    window._hsq?.push(command);
  }
}

/**
 * Set the current page path for tracking
 * Useful for single-page applications before calling trackPageView
 *
 * @param path - The path to set
 */
export function setPath(path: string): void {
  if (!path) {
    logger.info('HubSpot: Path is required');
    return;
  }

  try {
    pushToHubSpot(['setPath', path]);
  } catch (error) {
    logger.error('HubSpot: Failed to set path', error);
  }
}
